import { memo, useMemo, useEffect } from 'react';
import {
  DpSearch,
  DpSearchContent,
  HeaderPage,
  SearchField,
  SearchContainer,
  SearchInput,
  CancelBtn,
  ListResultSearch,
  Footer,
  FindDP,
  DpItem,
  DpContainer,
  DpDescription,
  SignInBtn,
  FilterButtonsContainer,
  FilterButton,
  NewLabel,
  PendingLabel,
} from './index.styled';
import useWindowSize from '../../utils/hooks/use-window-size';
import SearchIcon from '../../assets/images/blackSearch.svg';
import SearchDpIcon from '../../assets/images/searchDp.svg';
import Link from 'next/link';
import { MobileMenu } from '../profile-navigation/mobile-menu';
import { modals } from '../../constans/modals';
import { useSelector } from 'react-redux';

const FilterButtons = ({ currentTypeHandler, currentType, groupNames }) => {
  const userData = useSelector((state) => state.user.userData);

  const groupType = useMemo(() => {
    if (groupNames) {
      return {
        DP: {
          title: groupNames.dinner_party_verbose_name_plural,
          enum: 1,
          enable: groupNames.is_dinner_party_enabled,
        },
        TABLE: {
          title: groupNames.table_verbose_name_plural,
          enum: 4,
          enable: groupNames.is_table_enabled,
        },
        TEAM: {
          title: groupNames.team_verbose_name_plural,
          enum: 2,
          enable: groupNames.is_team_enabled,
        },
        ALL: {
          title: 'All',
          enum: 0,
          enable: true,
        },
      };
    }
    return {};
  }, [groupNames]);
  return (
    <FilterButtonsContainer>
      {Object.values(groupType).map((item) => (
        <>
          {item.enable &&
            <FilterButton
              key={item.title}
              activeBtn={currentType === item.enum}
              onClick={() => currentTypeHandler(item.enum)}
            >
              {item.title}
            </FilterButton>
          }
        </>
      ))}
    </FilterButtonsContainer>
  );
};

const DpSearchLayout = ({
  dpSearchResult,
  requestText,
  handleInput,
  clearInput,
  handleModalOpen,
  currentType,
  currentTypeHandler,
  groupNames,
}) => {
  const { width } = useWindowSize();
  const searchText = (() => {
    if (width < 365) return 'Search ...';
    if (width < 410) return 'Zip code or topic';
    return 'Search by zip code or topic';
  })();
  const { userData } = useSelector((state) => state.user);

  const editDateDP = (timestamp) => {
    if (timestamp) {
      const time = new Date(timestamp).toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: 'numeric',
      });
      const day = new Date(timestamp).toLocaleString('en-us', {
        weekday: 'long',
      });
      return `${day}, at ${time}`;
    } else return 'Time is not set';
  };

  return (
    <DpSearch>
      <DpSearchContent>
        <HeaderPage>
          <p>Group Search</p>
          {Object.keys(userData).length === 0 && (
            <SignInBtn
              onClick={() =>
                handleModalOpen({
                  type: modals.SIGN_IN_USER,
                  title: 'Sign In',
                })
              }
            >
              Sign in
            </SignInBtn>
          )}
        </HeaderPage>
        <SearchField>
          <SearchContainer>
            <SearchIcon />
            <SearchInput
              value={requestText}
              onChange={handleInput}
              placeholder={searchText}
            />
          </SearchContainer>

          <CancelBtn onClick={clearInput}>Cancel</CancelBtn>
        </SearchField>

        <FilterButtons
          currentTypeHandler={currentTypeHandler}
          currentType={currentType}
          groupNames={groupNames}
        />
        <ListResultSearch center={dpSearchResult.length === 0}>
          {dpSearchResult.length === 0 ? (
            <FindDP>
              <SearchDpIcon />
              <span>Find a Dinner Party to connect with.</span>
            </FindDP>
          ) : (
            dpSearchResult.map((item) => (
              <DpContainer key={item.id}>
                <Link
                  href={`/dinner-party/${item.id}/${item.title.toLowerCase()}`}
                >
                  <DpItem
                    preview={
                      item.preview && item.preview.replace(/[""]+/gm, '')
                    }
                  >
                    {item.is_new && <NewLabel>NEW</NewLabel>}
                    <DpDescription>
                      {item.type === 3 && item.status === 0 && (
                        <PendingLabel>PENDING</PendingLabel>
                      )}
                      <p>{item.title}</p>
                      <span>{editDateDP(item.first_meeting_date)}</span>
                    </DpDescription>
                  </DpItem>
                </Link>
              </DpContainer>
            ))
          )}

          {width < 610 && userData?.id && (
            <MobileMenu>
              <Footer style={{ marginBottom: 0 }}>
                <a target="_blank" href="https://www.gettogather.co">
                  <p>Copyright ©2022 Togather</p>
                </a>
              </Footer>
            </MobileMenu>
          )}
          <Footer absolute={dpSearchResult.length === 0}>
            <a target="_blank" href="https://www.gettogather.co">
              <p>Copyright ©2022 Togather</p>
            </a>
          </Footer>
        </ListResultSearch>
      </DpSearchContent>
    </DpSearch>
  );
};

export default memo(DpSearchLayout);
